/*
* Created on Jan 21, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import {useCallback, useState} from 'react';
import ic_search_svg from "../../../static/img/utils/ic-search.svg";
import {useTranslation} from "react-i18next";

const TableToolbarComponent = ({name, table_data, total_record, disPatcher, table_ui, isOwner, createText, permissions=null, search}) => {
    const {t} = useTranslation();
    const [query, setQuery] = useState('');
    const [active, setActive] = useState('');

    const onCreateClicked = () => {
        const type = `create_${name}`.toLowerCase().replace(' ', '_');
        disPatcher({type: type})
    }

    const onClickOpenAlert = () => {
        const type = `open_alert_delete_${name}`.toLowerCase().toLowerCase().replace(' ', '_');
        disPatcher({type: type});
    }

    const onQueryChange = (e) => {
        const type = `search_${name}`.toLowerCase().replace(' ', '_');
        const new_val = e.currentTarget.value;
        setQuery(()=> new_val);
        disPatcher({type, payload: new_val});
    }

    const onExportClick = () => {
        const type = `export_${name}`.toLowerCase().replace(' ', '_');
        disPatcher({type})
    }

    const disableDelete = useCallback(()=>{
        return table_data?.data.filter(d=>d.checked).length <= 0;
    }, [table_data]);

    return (
        <div className="toolbar">
            <div className="col-wrapper">
                <div className="col-left">
                    { (!table_ui || table_ui.toolbar.count) &&
                        <>
                            <div className="amount-info fs14 !ml-10">{t(`@${name}@`)}:<span className="hi-light !pl-8">{total_record || 0}</span></div>
                            {
                                ((table_ui?.toolbar.create_button && (isOwner || permissions?.invite_admin)) || (table_ui?.toolbar.delete_button && (isOwner || permissions?.invite_admin)) || table_ui?.toolbar.export_button) &&
                                <div className="func-divide !ml-16 !mr-16"/>
                            }
                        </>
                    }
                    <div className="q-btn-group">
                        { (!table_ui || table_ui.toolbar.create_button) && (isOwner || permissions?.invite_admin) &&
                            <button type="button"
                                 className="q-btn q-btn-primary q-btn-small q-btn-round-corner"
                                 onClick={onCreateClicked}>{ createText || `${t('@Create@')} ${t(`@${name}@`)}` }
                            </button>
                        }
                        { (!table_ui || table_ui.toolbar.delete_button) && (isOwner || permissions?.invite_admin) &&
                            <button type="button"
                                    className="q-btn q-btn-default q-btn-small q-btn-round-corner"
                                    disabled={disableDelete()}
                                    onClick={onClickOpenAlert}>{t('@Delete@')}
                            </button>
                        }
                        { (!table_ui || table_ui.toolbar.export_button) && (isOwner || permissions?.invite_admin) &&
                            <button type="button"
                                    className="q-btn q-btn-default q-btn-small q-btn-round-corner"
                                    onClick={onExportClick}>{t('@Export Activity Log@')}
                            </button>
                        }
                    </div>
                </div>
                {search &&
                    <div className="col-right">
                        <div className={`comp-search ${active}`}>
                            <img src={ic_search_svg} alt="" />
                            <div className="comp-input">
                                <input type="text" value={query} placeholder={`${t('@Search@')} ${t('@'+name+'@')}`}
                                       onChange={(e)=>onQueryChange(e)}
                                       onFocus={()=>setActive('active')}
                                       onBlur={()=>setActive('')}
                                />
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

export default TableToolbarComponent;